<template>
  <v-btn-toggle :value="window" mandatory dense @change="onChange">
    <v-btn
      v-for="opt in options"
      :key="opt.value"
      :value="opt.value"
      small
      :cypress-id="`window-${opt.value}`"
    >
      {{ opt.label }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ActivityWindowPicker',
  emits: ['changed'],
  data: () => ({
    options: [
      { value: 'DAYS_30', label: '30d' },
      { value: 'DAYS_90', label: '90d' },
      { value: 'MONTHS_6', label: '6mo' },
      { value: 'MONTHS_12', label: '12mo' },
    ],
  }),
  computed: {
    ...mapState('adminActivity', ['window']),
  },
  methods: {
    onChange(value) {
      // v-btn-toggle with `mandatory` emits `undefined` if the currently
      // selected button is clicked again - ignore that so the window
      // can't be cleared out from under the store.
      if (!value) return;
      this.$store.commit('adminActivity/setWindow', value);
      this.$emit('changed');
    },
  },
};
</script>
